import options from './splash-screen.component';

export default {
    selector: 'dtSplashScreen',
    options
};
